export class NuevoRepresentanteDTO {
    constructor(
        public nrRut: number,
        public dv: string,
        public nombres: string,
        public apellidos: string,
        public email:string
    ){
        this.nrRut=nrRut;
        this.dv=dv;
        this.nombres=nombres;
        this.apellidos=apellidos;
        this.email=email;
    }
}
